import React from 'react';
import { TypedMemo } from '../../common/types';
import { LoadingView } from '../../common/views/LoadingView';
import { SMLSmartLinksHome } from './SMLSmartLinksHome';
import { useAccountId } from '../../../redux/slices/appInfo/hooks';

const SmartLinksMainViewComponent: React.FC = () => {
  const accountId = useAccountId();

  if (accountId === null) {
    return <LoadingView />;
  }

  return <SMLSmartLinksHome accountId={accountId} />;
};

export const SmartLinksMainView = TypedMemo(SmartLinksMainViewComponent);
